// Module
var code = "<div class=\"container\"> <div class=\"row\"> <div class=\"PageNotFound\"> <h3 class=\"PageNotFound__title\">Uh oh! This page doesn't exist.</h3> <p> Double check the url and try again. Or head on over to the <a ui-sref=\"Landing\">homepage</a>. </p> </div> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/notFound/notFound.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;